module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance@2-7bd05771f31c132866feb3ccfae99cb9.jpg";